<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>

        <form [formGroup]="addUserForm">

          <div class="upperContainer">
            <mat-form-field appearance="outline" class="addFirstName">
              <mat-label for="firstName">First Name</mat-label>
              <input cdkFocusInitial #firstName matTooltip={{firstName.value}} matInput placeholder="First Name" formControlName="firstName"/>
              @if (addUserForm.get('firstName')?.invalid && (addUserForm.get('firstName')?.dirty || addUserForm.get('firstName')?.touched)) {
                <mat-error>
                  @if (addUserForm.get('firstName')?.errors?.['required']) {
                    First Name is required.
                  }
                  @if (addUserForm.get('firstName')?.errors?.['maxlength']) {
                    First Name must be no more than 35 characters long.
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="addLastName">
              <mat-label for="lastName">Last Name</mat-label>
              <input #lastName matTooltip={{lastName.value}} matInput placeholder="Last Name" formControlName="lastName"/>
              @if (addUserForm.get('lastName')?.invalid && (addUserForm.get('lastName')?.dirty || addUserForm.get('lastName')?.touched)) {
                <mat-error>
                  @if (addUserForm.get('lastName')?.errors?.['required']) {
                    Last Name is required.
                  }
                  @if (addUserForm.get('lastName')?.errors?.['maxlength']) {
                    Last Name must be no more than 35 characters long.
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="middleContainer">
            <mat-form-field appearance="outline" class="addRole">
              <mat-label>Role</mat-label>
              <mat-select #roleSelect matTooltip={{roleSelect.triggerValue}} formControlName="role" (selectionChange)="onRoleChange($event)">
                @for (role of roles$ | async; track $index; let last = $last) {
                <mat-option [value]="role.id">{{ role.name }}</mat-option>
                <mat-divider *ngIf="!$last"></mat-divider>
                }
              </mat-select>
              @if (addUserForm.get('role')?.invalid) {
                <mat-error>
                  @if (addUserForm.get('role')?.errors?.['required']) {
                    Role is required.
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="addOrganization">
              <mat-label>Organization{{ isAdminRole ? 's' : '' }}</mat-label>
              
              @if (!isAdminRole) {
                <mat-select #orgSelect 
                            [matTooltip]="getOrgTooltip()"
                            formControlName="org"
                            panelClass="searchable-panel">
                  <mat-option disabled>
                    <ngx-mat-select-search
                      [formControl]="orgSearchControl"
                      placeholderLabel="Search organizations..."
                      noEntriesFoundLabel="No organizations found">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (org of filteredOrgs$ | async; track $index; let last = $last) {
                  <mat-option [value]="org.id">{{ org.name }}</mat-option>
                  <mat-divider *ngIf="!$last" ></mat-divider>
                  }
                </mat-select>
              }
            
              @if (isAdminRole) {
                <mat-select #orgSelectMulti 
                            [matTooltip]="getOrgTooltip()"
                            formControlName="org"
                            multiple
                            panelClass="searchable-panel">
                  <mat-option disabled>
                    <ngx-mat-select-search
                      [formControl]="orgSearchControl"
                      placeholderLabel="Search organizations..."
                      noEntriesFoundLabel="No organizations found">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (org of filteredOrgs$ | async; track $index; let last = $last) {
                  <mat-option [value]="org.id">{{ org.name }}</mat-option>
                  <mat-divider *ngIf="!$last" ></mat-divider>
                  }
                </mat-select>
              }
              
              @if (addUserForm.get('org')?.invalid) {
                <mat-error>
                  @if (addUserForm.get('org')?.errors?.['required']) {
                    Organization{{ isAdminRole ? 's are' : ' is' }} required.
                  }
                </mat-error>
              }
            </mat-form-field>
        </div>

        <div class="lowerContainer">
          <div class="emailContainer">
            
          <mat-form-field appearance="outline" class="addEmail">
            <mat-label for="email">Email Address</mat-label>
            <input #email matTooltip={{email.value}} matInput placeholder="Email" formControlName="emailAddress" />
            @if (addUserForm.get('emailAddress')?.disabled) {
              <mat-hint>Email cannot be changed. Create a new user instead.</mat-hint>
            }
            @if (addUserForm.get('emailAddress')?.hasError('uniqueEmail')) {
              <mat-error>Email is Already Taken</mat-error>
            }
            @if (addUserForm.get('emailAddress')?.invalid && (addUserForm.get('emailAddress')?.dirty || addUserForm.get('emailAddress')?.touched)) {
              <mat-error>
                @if (addUserForm.get('emailAddress')?.errors?.['required']) {
                  Email is required.
                }
                @if (addUserForm.get('emailAddress')?.errors?.['pattern']) {
                  Email is not valid.
                }
                @if (addUserForm.get('emailAddress')?.errors?.['emailLength']) {
                  Email is too long.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
          <div *ngIf="data.user && !data.shouldPopulatedFieldsBeDisabled" class="checkboxContainer">
            <span id="checkboxLabel">Active</span>
            <mat-checkbox class="activeCheck" formControlName="active"></mat-checkbox>
          </div>
        </div>
      </form>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="actionContainer">

    @if (data.user != null ) {
      <div id="resetPasswordButtonContainer">

        <button
      mat-button
          id="resetPasswordButton"
          (click)="resetPassword()"
        >
          Reset Password
        </button>
      </div>
    }
    <button
    mat-button
    (click)="submitUser()"
    id="saveButton"
    [disabled]="!(isFormValid$ | async) || this.hasSaveButtonBeenPressed"
  >
    Save
  </button>
  <button mat-button mat-dialog-close>Close</button>
</div>
</mat-dialog-actions>
